import axios from 'axios';
import { Modal } from 'bootstrap';
import {trans} from 'js/utilities';

const openModal = (modal, url) => {
    const languageUrlBody = modal._element.querySelector('.language-url');
    const htmlContent = `<a href="${url}" class="btn btn-secondary">${trans('app.location_check.button')}</a>`;

    languageUrlBody.innerHTML = htmlContent;

    modal.show();
};

const getLocation = async (locale) => {
    try {
        const response = await axios.get(`/${locale}/check-location`);

        if (response.status === 200) {
            localStorage.setItem('location-check', true);

            return response.data;
        }

        return null;
    } catch {
        return null;
    }
};

(async () => {
    const locationCheck = localStorage.getItem('location-check');
    const languageNotificationModal = document.getElementById('language-notification-modal');

    if (!locationCheck && languageNotificationModal) {
        const modal = new Modal(document.getElementById('language-notification-modal'));
        const currentLocale = modal._element.getAttribute('current-locale');
        const languageData = await getLocation(currentLocale);

        if (languageData) {
            openModal(modal, languageData);
        }
    }
})();
